module.exports = __webpack_public_path__ + "img/dat_xe_ctv.c2a5368c.png";